import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_OPPORTUNITIES_REQUEST, fetchOpportunitiesFailure, fetchOpportunitiesSuccess } from "../../actions/opportunities/opportunitesActions";
import axios from "axios";
import qs from 'qs';
import iq_api_v2, { fetchSpotOpportunity } from "../../../../services/iqApiV2";
import { bannerService } from "../../../../context/BannerContext";


// Worker Saga
function* fetchOpportunitiesSaga() {
  try {
    const payload = yield select(
      (state) => state?.opportunitiesReducer?.payload
    );
    const {  clientName,accountName,userId,type } = payload;
    const data = yield call(
       fetchSpotOpportunity,
        clientName,accountName,userId,type
    );
    yield put(fetchOpportunitiesSuccess(data));
    // yield call(
    //   [bannerService, bannerService.publish],
    //   {
    //     message:
    //     "Spot Opportunities loaded",
    //     title:"Alert",
    //     type: 'info',
    //     duration: 2000
    //   }
    // )
  } catch (error) {
    yield put(fetchOpportunitiesFailure(error.message));
  }
}

// Watcher Saga
export function* watchOpportunitiesData() {
  yield takeLatest(FETCH_OPPORTUNITIES_REQUEST, fetchOpportunitiesSaga);
}
